import SVGIcon from "components/Icons/SVGIcon"
import React from "react"
import TemplatesIcon from "components/Icons/Templates.icon"
import AbsenceIcon from "components/Icons/Absence.icon"
import { FeatureFlagTypes } from "components/SupportSettingsToggler/types"
import { Roles } from "./models/user"
import { EmployeeSettingsRoutes } from "./routes/types"

export type AppLayout = "desktop" | "mobile"
export interface NavigationItemObject {
  icon: JSX.Element
  name: string
  nameMobile?: string
  to: string
  allowedRoles: Roles[]
  visible: AppLayout[]
  featureFlag?: FeatureFlagTypes
}

export const navigationItems: NavigationItemObject[] = [
  {
    icon: <SVGIcon path="svg-personalplanning" />,
    name: "navigationItem.personalplanning",
    nameMobile: "navigationItem.personalplanning_mobile",
    to: "/personal-planning",
    allowedRoles: [Roles.Planner, Roles.HROfficer, Roles.User],
    visible: ["mobile", "desktop"],
  },
  {
    icon: <SVGIcon path="svg-planning" />,
    name: "navigationItem.planning",
    nameMobile: "navigationItem.planning_mobile",
    to: "/planning",
    allowedRoles: [Roles.Planner, Roles.HROfficer, Roles.User],
    visible: ["mobile", "desktop"],
  },
  {
    icon: <AbsenceIcon fontSize="large" />,
    name: "navigationitem.personal_absence",
    to: `/${EmployeeSettingsRoutes.PersonalAbsences}`,
    allowedRoles: [Roles.User],
    visible: ["desktop"],
    featureFlag: FeatureFlagTypes.LeaveEntitlements,
  },
  {
    icon: <AbsenceIcon fontSize="large" />,
    name: "navigationitem.personal_absence_mobile",
    to: `/${EmployeeSettingsRoutes.PersonalAbsences}`,
    allowedRoles: [Roles.User, Roles.Planner, Roles.HROfficer],
    visible: ["mobile"],
    featureFlag: FeatureFlagTypes.LeaveEntitlements,
  },
  {
    icon: <TemplatesIcon fontSize="large" />,
    name: "navigationItem.templates",
    to: "/templates",
    allowedRoles: [Roles.Planner],
    visible: ["desktop"],
  },
  {
    icon: <SVGIcon path="svg-absences" />,
    name: "navigationItem.absences",
    to: "/absences",
    allowedRoles: [Roles.Planner, Roles.HROfficer],
    visible: ["desktop"],
  },
  {
    icon: <SVGIcon path="svg-employees" />,
    name: "navigationItem.employees",
    to: "/employees",
    allowedRoles: [Roles.Planner, Roles.HROfficer],
    visible: ["desktop"],
  },
]
